import { OrderConfirmationModal } from './../orderconfirmation/orderconfirmation.component';
import { Component, OnInit, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data/data.service';

@Component({
  selector: 'mobile-order-confirmation-modal',
  template: require('./mobile-order-confirmation-modal.component.html'),
  styles: [require('./mobile-order-confirmation-modal.component.css')]
})
export class MobileOrderConfirmationModalComponent extends OrderConfirmationModal {

  get horizontal()
  {
    return this.workspace.horizontalMode;
  }
  
  constructor(
    injector: Injector,
    protected router: Router,
    protected fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public dataService: DataService
  ) {
      super(injector, router, fb, activeModal, dataService);
  }
}
